<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-md-5">
                    <user-card :user="$auth.user" :show-email="true"></user-card>
                    <user-avatar :id="$auth.user.id" :user="$auth.user" @changed="avatarChanged"></user-avatar>
                </div>
                <div class="col-md-7">
                    <user-data-card v-model="$auth.user"></user-data-card>
                    <change-password-card v-if="$auth.user.source == 'internal'"></change-password-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ChangePasswordCard from './components/ChangePasswordCard'
    import UserCard from './components/UserCard'
    import UserDataCard from './components/UserDataCard'
    import UserAvatar from '../accounts/users/UserAvatar'

    export default {

        components: {
            UserCard, ChangePasswordCard, UserDataCard, UserAvatar
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('auth.my-account'),
                    },
                ]
            }
        },

        methods: {
            avatarChanged(user) {
                // Be sure not to loose some user data.
                let updatedUser = {...this.$auth.user}
                updatedUser.avatar = user.avatar
                this.$auth.user = updatedUser
            }
        }
    }
</script>
